

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Global, Reports } from '@/store';
import { i18n } from '@/main';
import InventoryExportData from '@/pages/reports/components/InventoryExportData.vue';

@Component({ components: {
        InventoryExportData
    }
})
class InventoryTable extends Vue {
    @Prop() search_fields;
    @Prop() commissioned_devices;

    @Global.State('lang') lang;

    loading = true;
    tableData = [];
    message = '';
    headers = ['ID', 'Name', 'Cabinet ID', 'Circuit Number', 'Pole Number'];
    devices = [];
    filter_fields = {};

    mounted(){
        this.setTableData();
    }

    @Watch('search_fields')
    setTableData(){
        this.loading = true;
        this.devices = this.commissioned_devices;
        this.generateTableData();
        this.filter_fields = {};
        this.search_fields.forEach((field) => {
            this.filter_fields[field.name] = field.selected.toString();
        });
        this.loading = false;
    }

    generateTableData(){
        this.tableData = [];
        this.search_fields.forEach((field) => {
            this.devices = this.devices.filter((device) => {
                const field_value = device['meta.device'][field.name];
                if (!field_value) return false;
                return field.selected.includes(field_value.toString());
            });
        });

        if (!this.devices.length) return;

        this.tableData = this.devices.map((device) => ({
            id: device.id, 
            name: device.name, 
            cabinet_id: device['meta.device'].cabinet_id,
            circuit_number: device['meta.device'].circuit_number,
            pole_number: device['meta.device'].pole_number
        }));

        this.tableData.sort((device1, device2) => device1.cabinet_id - device2.cabinet_id);
    }
}

export default InventoryTable;
